/**
 * Campus Framework API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@bitapp.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum FileFileableType {
    Day = 'day',
    EventInvoice = 'event_invoice',
    Invoice = 'invoice',
    ServicesCost = 'services_cost',
    ThirdPartyCompany = 'third_party_company',
    AttendanceRegister = 'attendance_register',
    Certificate = 'certificate',
    Course = 'course',
    CourseSummaryDocument = 'course_summary_document',
    Edition = 'edition',
    ExternalCertificationTest = 'external_certification_test',
    ExternalCertificationTime = 'external_certification_time',
    MediaLibraryObject = 'media_library_object',
    News = 'news',
    Curriculum = 'curriculum',
    FixedCosts = 'fixed_costs'
};

